import { endOfDay, isValid } from 'date-fns';

function isDateStringValid(date: string, delimiter = '/') {
  const dates = date.split(delimiter);

  if (dates.length !== 3) {
    return false;
  }

  const _date = new Date(Number(dates.pop()), Number(dates.pop()) - 1, Number(dates.pop()));

  return isValid(_date) && _date;
}

function isEndOfDay(date: Date) {
  return +date === +endOfDay(date);
}

export { isDateStringValid, isEndOfDay };
